var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_attenzione",
    "data-name": "icona attenzione",
    transform: "translate(-343 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_attenzione-2",
    "data-name": "icona attenzione",
    transform: "translate(343 0.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(0 5.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_989",
    "data-name": "Raggruppa 989",
    transform: "translate(0 14.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_211",
    "data-name": "Tracciato 211",
    d: "M15.668,26.3l-5.652-10.39a2.344,2.344,0,0,0-4.031,0L.333,26.3a2.343,2.343,0,0,0,2.015,3.54h11.3A2.343,2.343,0,0,0,15.668,26.3ZM8,27.961a.938.938,0,1,1,.938-.937A.939.939,0,0,1,8,27.961Zm.938-3.75a.938.938,0,0,1-1.875,0V19.524a.938.938,0,0,1,1.875,0Z",
    transform: "translate(0 -14.759)",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_766",
    "data-name": "Rettangolo 766",
    transform: "translate(343 20)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.18d405f77cc4f7cbe4a203bf8d2bffce.svg";
export { ForwardRef as ReactComponent };